// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3189":"59a357945df0c042","3889":"05a825c8d463dc86","8472":"29f54eaa2b4099b4"}[chunkId] + ".css";
};